import { ReactNode } from "react";

interface Props {
  title: string;
  action?: ReactNode;
  onAction?: () => void;
  children: ReactNode;
  className?: string;
}

export default function AtriumPanel({ title, action, onAction, children, className }: Props) {
  return (
    <div className={`a-card flex flex-col ${className ?? ""}`}>
      <div
        className="flex items-center px-[14px] py-3 border-b"
        style={{ borderColor: "var(--a-border)" }}
      >
        <div
          className="text-[12px] font-semibold uppercase tracking-[0.06em]"
          style={{ color: "var(--a-muted)" }}
        >
          {title}
        </div>
        {action && (
          <div
            onClick={onAction}
            className="ml-auto text-[11px] cursor-pointer"
            style={{ color: "var(--a-faint)" }}
          >
            {action}
          </div>
        )}
      </div>
      <div className="py-2">{children}</div>
    </div>
  );
}
